import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    currentPage: 'calendar',
    storeCategory: null,
    showMenu: false,
    showSettings: false,
    settingsTab: 'account',
    showShareCalendar: false,
    imageViewer: null, // { images: string[], initialIndex: number } or null
    darkMode: false,
    // Menu states (moved from menusSlice)
    calendarDayDate: null,
    dayMenuOtherUserDate: null, // { date, userId }
    profileViewing: null, // { id, tab }
    eventData: null, // Full event data object { id, title, contact, status, note, date }
    eventWindowData: null, // { day: string, eventId?: string, contactId?: string }
    desktopMenu: null, // { type: "event" | "prediction", eventId?: string, userId?: string, date: string }
    helpMenu: null, // string key for help content, or null = closed
    testViewer: null, // { test: object, uploading: boolean } or null
    imagePredictionMenu: null, // { test: object, predictionData: object } or null
  },
  reducers: {
    setPage: (state, action) => {
      state.currentPage = action.payload;
      state.imageViewer = null; // Clear image viewer when changing pages
      // Clear all menu states when page changes
      state.calendarDayDate = null;
      state.dayMenuOtherUserDate = null;
      state.profileViewing = null;
      state.eventMenu = null;
      state.desktopMenu = null;
      // Don't clear helpMenu if it's an onboarding menu (calendar_welcome, profile_welcome, share_welcome)
      const onboardingMenus = ['calendar_welcome', 'profile_welcome', 'share_welcome'];
      if (!onboardingMenus.includes(state.helpMenu)) {
        state.helpMenu = null;
      }
      state.testViewer = null;
    },
    setStoreCategory: (state, action) => {
      state.storeCategory = action.payload;
    },
    setShowMenu: (state, action) => {
      state.showMenu = action.payload;
    },
    setShowSettings: (state, action) => {
      state.showSettings = action.payload;
    },
    setSettingsTab: (state, action) => {
      state.settingsTab = action.payload;
    },
    setShowShareCalendar: (state, action) => {
      state.showShareCalendar = action.payload;
    },
    setImageViewer: (state, action) => {
      state.imageViewer = action.payload; // null to close, { images, initialIndex } to open
    },
    // Menu reducers (moved from menusSlice)
    setDayMenuDate: (state, action) => {
      state.calendarDayDate = action.payload;
    },
    setDayMenuOtherUserDate: (state, action) => {
      state.dayMenuOtherUserDate = action.payload;
    },
    setProfileViewing: (state, action) => {
      state.profileViewing = action.payload;
    },
    setEventData: (state, action) => {
      state.eventData = action.payload;
    },
    setEventWindowData: (state, action) => {
      state.eventWindowData = action.payload;
    },
    setDesktopMenu: (state, action) => {
      state.desktopMenu = action.payload;
    },
    setHelpMenu: (state, action) => {
      state.helpMenu = action.payload;
    },
    setTestViewer: (state, action) => {
      state.testViewer = action.payload;
    },
    setImagePredictionMenu: (state, action) => {
      state.imagePredictionMenu = action.payload;
    },
    setDarkMode: (state, action) => {
      state.darkMode = action.payload;
    },
  },
});

export const { setPage, setStoreCategory, setShowMenu, setShowSettings, setSettingsTab, setShowShareCalendar, setImageViewer, setDayMenuDate, setDayMenuOtherUserDate, setProfileViewing, setEventData, setEventWindowData, setDesktopMenu, setHelpMenu, setTestViewer, setImagePredictionMenu, setDarkMode } = uiSlice.actions;
export default uiSlice.reducer;
